import DominioServico from '@/servicos/DominioServico'
const dominioServico = new DominioServico()

export const dominioMixin = {
  methods: {
    recuperarValoresDominio(nome) {
      return dominioServico.recuperarValoresDominio({ nome })
    },
  },
}
